import { gql } from "graphql-request";
import { requestAndFormat } from "../utils";

export const deleteAllFilesMutation = (params: {
	itemId: string;
	boardId: string;
	columnId?: string;
}) =>
	requestAndFormat(
		{
			defaultParams: {
				value: JSON.stringify({ clear_all: true }),
			},
			gql: gql`
				mutation DeleteAllFileMutation(
					$itemId: ID!,
					$boardId: ID!
					$columnId: String!
					$value: JSON!
				) {
					change_column_value(
						board_id: $boardId
						item_id: $itemId
						column_id: $columnId
						value: $value
					) {
						id
					}
				}`,
			skipMondayFormatting: true,
			resultKey: "change_column_value",
			outType: {} as { id: string },
		},
		params,
	);
